(function() {

	var heroTitle = document.querySelector('[data-hero-title]');
	var heroVideo = document.querySelector('[data-hero-asset] video');

	window.addEventListener('scroll', function () {

		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (heroTitle) heroTitle.style.transform = "translateY(" + (scrollTop * -0.4) + "px";
		if (heroVideo) heroVideo.style.transform = "translateY(" + (scrollTop * -0.1) + "px";

	}, false);

})();

(function () {

	var attributeName = 'data-intersection-observer';

	var elements = document.querySelectorAll('[' + attributeName + ']');
	var observer;
	var isSupported = 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;

	if (!elements.length) return;

	if (!isSupported) {

		for (var i = 0; i < elements.length; i++) {

			(function (i) {

				elements[i].setAttribute(attributeName, 'visible');

			})(i);

		}

		return;

  }

	observer = new IntersectionObserver(function (entries) {

		for (var i = 0; i < entries.length; i++) {

			(function (i) {

				if (entries[i].isIntersecting) {

					entries[i].target.setAttribute(attributeName, 'visible');

				}

			})(i);

		}

	}, { threshold: 0.5 });

	for (var i = 0; i < elements.length; i++) {

		(function (i) {

			observer.observe(elements[i]);

		})(i);

	}

})();